export default "__VITE_ASSET__wEwdKMrN__"